import { initMenu } from './menu';
import { initMailchimp } from './mailchimp';
import { initAnalytics } from './analytics';

initMenu();
initMailchimp();
initAnalytics();
